"use client";

import { Input } from "@/components/ui/input";

export async function readGithubPemFile(file: File): Promise<string> {
  if (file.size <= 0 || file.size > 64 * 1024) {
    throw new Error("The GitHub private-key file must be a non-empty .pem file smaller than 64 KB.");
  }

  const text=(await file.text()).replace(/^\uFEFF/,"").trim();
  const supported=
    text.includes("-----BEGIN RSA PRIVATE KEY-----") ||
    text.includes("-----BEGIN PRIVATE KEY-----");

  if (!supported) {
    throw new Error("That file is not a supported GitHub App private-key PEM. Choose the .pem file downloaded from GitHub.");
  }
  return text;
}

export function GithubPemCredentialInput({
  selectedName,
  onSelectedNameChange,
  onPemLoaded,
  onError,
  className="",
}:{
  selectedName:string | null;
  onSelectedNameChange:(name:string | null)=>void;
  onPemLoaded:(pem:string)=>void;
  onError:(message:string)=>void;
  className?:string;
}) {
  return (
    <>
      <Input
        type="file"
        accept=".pem,.key,application/x-pem-file,text/plain"
        className={className}
        onChange={(event)=>{
          const file=event.target.files?.[0] ?? null;
          if(!file) return;
          void readGithubPemFile(file)
            .then((pem)=>{
              onPemLoaded(pem);
              onSelectedNameChange(file.name || "GitHub App private key.pem");
            })
            .catch((error)=>{
              onPemLoaded("");
              onSelectedNameChange(null);
              onError(error instanceof Error ? error.message : "Could not read the GitHub private-key file.");
            });
          event.currentTarget.value="";
        }}
      />
      <p className="mt-1 text-[9px] text-foreground/38">
        {selectedName ? "Loaded: " + selectedName : "No .pem file selected."}
      </p>
    </>
  );
}
